import * as React from "react";

import { NewCheckBox as CheckBox } from "common/components/checkBox";
import TinySquareStackedImage from "common/components/squareStackedImage/tinySquareStackedImage";
import ShavedText from "common/components/shavedText";

const styles = require("./withSelection.scss");
const COLLECTION_NAME_ELEMENT_MAX_WIDTH = 125;

interface IBase {
  checked: boolean;
  onChange: (checkState: boolean, returnValue: any) => void;
  returnValue?: any;
}

interface ISimpleSelectItem extends IBase {
  text: string;
}

interface ICollectionSelectItem extends IBase {
  collectionSrc: string;
  title: string;
  color?: string;
  isPrivate: boolean;
}

const SimpleSelectItem: React.FC<ISimpleSelectItem> = ({
  text,
  checked,
  onChange,
  returnValue,
}) => {
  return (
    <div className={styles.rowItem}>
      <CheckBox
        checkBoxClassName={styles.checkbox}
        checked={checked}
        checkedValue={returnValue}
        unCheckedValue={returnValue}
        onChange={onChange}
      >
        {text}
      </CheckBox>
    </div>
  );
};

const CollectionSelectItem: React.FC<ICollectionSelectItem> = ({
  collectionSrc,
  title,
  checked,
  color,
  isPrivate,
  onChange,
  returnValue,
}) => {
  const [isShaved, setShaved] = React.useState(false);
  const collectionTitleRef = React.useRef<HTMLSpanElement>(null);

  React.useLayoutEffect(() => {
    const titleElement = collectionTitleRef.current;
    if (titleElement) {
      const width = (titleElement as Element).clientWidth;
      if (width > COLLECTION_NAME_ELEMENT_MAX_WIDTH) {
        setShaved(true);
      }
    }
  }, [title]);

  return (
    <div className={styles.rowItem}>
      <CheckBox
        checkBoxClassName={styles.checkbox}
        checked={checked}
        checkedValue={returnValue}
        unCheckedValue={returnValue}
        onChange={onChange}
      >
        <div className={styles.checkBoxInner}>
          <TinySquareStackedImage
            src={collectionSrc}
            color={color}
            isPrivate={isPrivate}
            width={24}
            height={24}
            title={title}
            imgStyles={{
              width: 24,
              height: 24,
            }}
            borderOneWidth={20}
            borderTwoWidth={18}
            className={styles.collectionThumbnail}
            privateIconWrapperClassName={styles.privateIconWrapper}
            privateIconClassName={styles.icon}
          />
          <span className={styles.collectionName} data-shaved={isShaved}>
            <span ref={collectionTitleRef} className={styles.marqueeBox}>
              {title}
            </span>
            <ShavedText
              value={title}
              shaveHeight={18}
              className={styles.shaveText}
            />
          </span>
        </div>
      </CheckBox>
    </div>
  );
};

export { SimpleSelectItem, CollectionSelectItem };
